import { st, classes } from './odeditor.st.css';
export default (function (_ref) {
  var darkMode = _ref.darkMode;
  return st(classes.root, {
    darkMode: darkMode
  });
});